{
  "familyId": "TOPO-NL-STEDEN",
  "questions": [
    {
      "id": "TOPO-NL-STEDEN-001",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Een toerist vraagt aan een Nederlander: 'Wat is de hoofdstad van jullie land?' Wat is het juiste antwoord?",
      "options": [
        "Amsterdam",
        "Den Haag",
        "Rotterdam",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad vs. regeringszetel",
            "content": "Amsterdam is de officiële hoofdstad van Nederland. Den Haag is de regeringszetel (daar zit de Tweede Kamer en de regering). Dit is een bekende strikvraag!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "nl_hoofdstad",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Amsterdam is de hoofdstad van Nederland. Den Haag is de regeringszetel (daar zit de regering), maar Amsterdam is officieel de hoofdstad.",
        "solutionSteps": [
          "Amsterdam is de hoofdstad van Nederland",
          "Den Haag is de regeringszetel, niet de hoofdstad"
        ],
        "distractorExplanations": {
          "0": "Goed! Amsterdam is de officiële hoofdstad van Nederland.",
          "1": "Den Haag is de regeringszetel (daar zit de Tweede Kamer en de regering), maar Amsterdam is de officiële hoofdstad. Dit is een veelgemaakte fout!",
          "2": "Rotterdam is de tweede stad van Nederland en heeft de grootste haven van Europa, maar het is niet de hoofdstad.",
          "3": "Utrecht ligt centraal in Nederland, maar het is niet de hoofdstad. Amsterdam is de hoofdstad."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-001-OPT1",
            "optionIndex": 1,
            "label": "Dit is een veelgemaakte fout!"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-001-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Rotterdam"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-001-OPT3",
            "optionIndex": 3,
            "label": "Amsterdam is de hoofdstad"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-002",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Een scheepvaartbedrijf heeft zijn kantoor in Rotterdam. In welke provincie staat dat kantoor?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Utrecht",
        "Zeeland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rotterdam en Zuid-Holland",
            "content": "Rotterdam ligt in Zuid-Holland. Amsterdam ligt in Noord-Holland. Verwar deze twee provincies niet! Rotterdam = Zuid-Holland, Amsterdam = Noord-Holland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rotterdam_provincie",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Rotterdam ligt in de provincie Zuid-Holland. Het is de tweede stad van Nederland en heeft de grootste haven van Europa.",
        "solutionSteps": [
          "Rotterdam ligt in Zuid-Holland",
          "Amsterdam ligt in Noord-Holland",
          "Verwar Zuid-Holland en Noord-Holland niet!"
        ],
        "distractorExplanations": {
          "0": "Goed! Rotterdam ligt in Zuid-Holland.",
          "1": "Noord-Holland is de provincie van Amsterdam en Haarlem, niet van Rotterdam.",
          "2": "Utrecht is een aparte provincie met de stad Utrecht. Rotterdam ligt in Zuid-Holland.",
          "3": "Zeeland ligt ten zuiden van Zuid-Holland. Rotterdam ligt in Zuid-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-002-OPT2",
            "optionIndex": 2,
            "label": "Rotterdam ligt in Zuid-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-002-OPT3",
            "optionIndex": 3,
            "label": "Zeeland ligt ten zuiden van Zuid-Holland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-003",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Een containerschip vaart Europa binnen. De kapitein wil naar de grootste haven van Europa. Naar welke stad vaart hij?",
      "options": [
        "Rotterdam",
        "Amsterdam",
        "Antwerpen",
        "Hamburg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Haven van Rotterdam",
            "content": "Rotterdam heeft de grootste haven van Europa. De haven heet ook wel Europoort. Antwerpen (België) heeft de tweede haven van Europa.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rotterdam_haven",
      "variantIndex": 3,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.8,
      "feedback": {
        "explanationText": "Rotterdam heeft de grootste haven van Europa. De Rotterdamse haven (inclusief de Maasvlakte) is een van de grootste ter wereld.",
        "solutionSteps": [
          "Rotterdam heeft de grootste haven van Europa",
          "De haven heet ook wel 'Europoort'"
        ],
        "distractorExplanations": {
          "0": "Goed! Rotterdam heeft de grootste haven van Europa.",
          "1": "Amsterdam heeft ook een haven, maar die is veel kleiner dan die van Rotterdam.",
          "2": "Antwerpen (België) heeft de tweede haven van Europa, maar Rotterdam is groter.",
          "3": "Hamburg (Duitsland) heeft een grote haven, maar Rotterdam is de grootste van Europa."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-003-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Amsterdam"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Antwerpen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Hamburg"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-004",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Een leerling maakt een overzicht van provinciehoofdsteden. Welke stad hoort daar NIET in?",
      "options": [
        "Eindhoven",
        "Groningen",
        "Maastricht",
        "Leeuwarden"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Provinciehoofdsteden",
            "content": "Eindhoven is NIET de hoofdstad van Noord-Brabant — dat is 's-Hertogenbosch (Den Bosch). Eindhoven is wel de grootste stad. Groningen, Maastricht en Leeuwarden zijn wél provinciehoofdsteden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geen_hoofdstad_eindhoven",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Eindhoven is niet de hoofdstad van Noord-Brabant — dat is 's-Hertogenbosch (Den Bosch). Eindhoven is wel de grootste stad van Noord-Brabant.",
        "solutionSteps": [
          "Eindhoven is NIET de hoofdstad van Noord-Brabant",
          "'s-Hertogenbosch (Den Bosch) is de hoofdstad van Noord-Brabant",
          "Groningen, Maastricht en Leeuwarden zijn wél provinciehoofdsteden"
        ],
        "distractorExplanations": {
          "0": "Goed! Eindhoven is niet de provinciehoofdstad — 's-Hertogenbosch is de hoofdstad van Noord-Brabant.",
          "1": "Groningen is wél de hoofdstad van de provincie Groningen.",
          "2": "Maastricht is wél de hoofdstad van de provincie Limburg.",
          "3": "Leeuwarden is wél de hoofdstad van de provincie Friesland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-004-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Groningen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Maastricht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-004-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Leeuwarden"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-005",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Amsterdam",
            "right": "Noord-Holland"
          },
          {
            "left": "Groningen",
            "right": "Groningen"
          },
          {
            "left": "Maastricht",
            "right": "Limburg"
          },
          {
            "left": "Leeuwarden",
            "right": "Friesland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Amsterdam → Noord-Holland, Groningen → Groningen (stad en provincie dezelfde naam), Maastricht → Limburg (zuiden), Leeuwarden → Friesland (noorden).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_provincies_match",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Amsterdam ligt in Noord-Holland, Groningen in de provincie Groningen, Maastricht in Limburg en Leeuwarden in Friesland.",
        "solutionSteps": [
          "Amsterdam → Noord-Holland",
          "Groningen → Groningen (stad en provincie hebben dezelfde naam)",
          "Maastricht → Limburg (in het zuiden)",
          "Leeuwarden → Friesland (in het noorden)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-006",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Een ambtenaar moet naar het provinciebestuur van Noord-Brabant. Naar welke stad moet hij reizen?",
      "options": [
        "'s-Hertogenbosch",
        "Eindhoven",
        "Breda",
        "Tilburg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad Noord-Brabant",
            "content": "'s-Hertogenbosch (ook wel Den Bosch genoemd) is de hoofdstad van Noord-Brabant. Eindhoven is de grootste stad, maar niet de hoofdstad. Het provinciebestuur zit in 's-Hertogenbosch.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "brabant_hoofdstad",
      "variantIndex": 6,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'s-Hertogenbosch (Den Bosch) is de hoofdstad van Noord-Brabant. Veel mensen denken dat Eindhoven de hoofdstad is omdat het de grootste stad is, maar het provinciebestuur zit in 's-Hertogenbosch.",
        "solutionSteps": [
          "Het provinciebestuur zit in de hoofdstad van de provincie",
          "De hoofdstad van Noord-Brabant is 's-Hertogenbosch (Den Bosch)",
          "Eindhoven is de grootste stad, maar niet de hoofdstad"
        ],
        "distractorExplanations": {
          "0": "Goed! 's-Hertogenbosch (Den Bosch) is de hoofdstad van Noord-Brabant.",
          "1": "Eindhoven is de grootste stad van Noord-Brabant, maar niet de hoofdstad. De hoofdstad is 's-Hertogenbosch.",
          "2": "Breda is een grote stad in het westen van Noord-Brabant, maar niet de hoofdstad.",
          "3": "Tilburg is een grote stad in het midden van Noord-Brabant, maar niet de hoofdstad."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-006-OPT1",
            "optionIndex": 1,
            "label": "De hoofdstad is 's-Hertogenbosch"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-006-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Breda"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-006-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Tilburg"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-007",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van de provincie Limburg?",
      "options": [
        "Maastricht",
        "Heerlen",
        "Venlo",
        "Roermond"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad Limburg",
            "content": "Maastricht is de hoofdstad van Limburg. Het ligt in het uiterste zuiden van Nederland, aan de Maas.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "limburg_hoofdstad",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Maastricht is de hoofdstad van Limburg. Het is een van de oudste steden van Nederland en ligt aan de Maas in het uiterste zuiden.",
        "solutionSteps": [
          "Limburg is de meest zuidelijke provincie van Nederland",
          "De hoofdstad is Maastricht (aan de Maas)"
        ],
        "distractorExplanations": {
          "0": "Goed! Maastricht is de hoofdstad van Limburg.",
          "1": "Heerlen is een grote stad in Zuid-Limburg, maar niet de hoofdstad.",
          "2": "Venlo is een stad in Noord-Limburg, aan de Maas bij de Duitse grens. De hoofdstad is Maastricht.",
          "3": "Roermond is een stad in Midden-Limburg. De hoofdstad is Maastricht."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-007-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Heerlen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-007-OPT2",
            "optionIndex": 2,
            "label": "De hoofdstad is Maastricht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-007-OPT3",
            "optionIndex": 3,
            "label": "Roermond is een stad in Midden-Limburg"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-008",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Een technologiebedrijf zoekt een vestiging in de grootste stad van Noord-Brabant. Welke stad is dat?",
      "options": [
        "Eindhoven",
        "'s-Hertogenbosch",
        "Tilburg",
        "Breda"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eindhoven: technologiestad",
            "content": "Eindhoven is de grootste stad van Noord-Brabant. Het staat bekend als technologiestad vanwege bedrijven als Philips en ASML. Let op: Eindhoven is de grootste stad, maar 's-Hertogenbosch is de hoofdstad!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "eindhoven_grootste",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Eindhoven is de grootste stad van Noord-Brabant. Het staat bekend als technologiestad: Philips werd hier opgericht en ASML zit er.",
        "solutionSteps": [
          "De grootste stad van Noord-Brabant is Eindhoven",
          "Let op: grootste stad ≠ hoofdstad! De hoofdstad is 's-Hertogenbosch"
        ],
        "distractorExplanations": {
          "0": "Goed! Eindhoven is de grootste stad van Noord-Brabant.",
          "1": "'s-Hertogenbosch is de hoofdstad, maar niet de grootste stad.",
          "2": "Tilburg is de op één na grootste stad van Noord-Brabant.",
          "3": "Breda is een grote stad in het westen van Noord-Brabant, maar Eindhoven is groter."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-008-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: 's-Hertogenbosch"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-008-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Tilburg"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-008-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Breda"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-009",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Een treinreiziger stapt in Arnhem op de trein richting Duitsland. In welke provincie vertrekt hij?",
      "options": [
        "Gelderland",
        "Overijssel",
        "Noord-Brabant",
        "Limburg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Arnhem: grensstad in Gelderland",
            "content": "Arnhem is de hoofdstad van Gelderland en ligt in het oosten van Nederland, dicht bij de Duitse grens.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "arnhem_gelderland",
      "variantIndex": 9,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Arnhem is de hoofdstad van de provincie Gelderland en ligt in het oosten van Nederland, dicht bij de Duitse grens.",
        "solutionSteps": [
          "Arnhem is de hoofdstad van Gelderland",
          "Gelderland ligt in het oosten van Nederland"
        ],
        "distractorExplanations": {
          "0": "Goed! Arnhem is de hoofdstad van Gelderland.",
          "1": "Overijssel ligt ten noorden van Gelderland. Zwolle en Enschede liggen in Overijssel.",
          "2": "Noord-Brabant ligt ten zuiden van Gelderland.",
          "3": "Limburg ligt in het zuidoosten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-009-OPT1",
            "optionIndex": 1,
            "label": "Overijssel ligt ten noorden van Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-009-OPT2",
            "optionIndex": 2,
            "label": "Noord-Brabant ligt ten zuiden van Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-009-OPT3",
            "optionIndex": 3,
            "label": "Limburg ligt in het zuidoosten"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-010",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van de provincie Overijssel?",
      "options": [
        "Zwolle",
        "Enschede",
        "Deventer",
        "Almelo"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad Overijssel",
            "content": "Zwolle is de hoofdstad van Overijssel. Enschede is de grootste stad, maar niet de hoofdstad. Overijssel ligt in het oosten van Nederland, boven Gelderland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "overijssel_hoofdstad",
      "variantIndex": 10,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Zwolle is de hoofdstad van Overijssel. Enschede is de grootste stad van de provincie, maar het provinciebestuur zit in Zwolle.",
        "solutionSteps": [
          "Overijssel ligt in het oosten van Nederland",
          "De hoofdstad is Zwolle",
          "Enschede is de grootste stad, maar niet de hoofdstad"
        ],
        "distractorExplanations": {
          "0": "Goed! Zwolle is de hoofdstad van Overijssel.",
          "1": "Enschede is de grootste stad van Overijssel, maar niet de hoofdstad. De hoofdstad is Zwolle.",
          "2": "Deventer is een historische Hanzestad in Overijssel, maar niet de hoofdstad.",
          "3": "Almelo is een stad in Twente (Overijssel), maar niet de hoofdstad."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-010-OPT1",
            "optionIndex": 1,
            "label": "De hoofdstad is Zwolle"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-010-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Deventer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-010-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Almelo"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-011",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van de provincie Flevoland?",
      "options": [
        "Lelystad",
        "Almere",
        "Dronten",
        "Emmeloord"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad Flevoland",
            "content": "Lelystad is de hoofdstad van Flevoland. Almere is de grootste stad, maar niet de hoofdstad. Lelystad is vernoemd naar Cornelis Lely, de ingenieur van de Zuiderzeewerken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flevoland_hoofdstad",
      "variantIndex": 11,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Lelystad is de hoofdstad van Flevoland, de jongste provincie van Nederland. Almere is veel groter, maar het provinciebestuur zit in Lelystad.",
        "solutionSteps": [
          "Flevoland is de jongste provincie (1986)",
          "De hoofdstad is Lelystad (vernoemd naar Cornelis Lely)",
          "Almere is de grootste stad, maar niet de hoofdstad"
        ],
        "distractorExplanations": {
          "0": "Goed! Lelystad is de hoofdstad van Flevoland.",
          "1": "Almere is de grootste stad van Flevoland (en een van de snelst groeiende steden van Nederland), maar de hoofdstad is Lelystad.",
          "2": "Dronten is een kleinere stad in Flevoland, niet de hoofdstad.",
          "3": "Emmeloord ligt in de Noordoostpolder (Flevoland), maar is niet de hoofdstad."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-011-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Almere"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-011-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Dronten"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-011-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Emmeloord"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-012",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van de provincie Drenthe?",
      "options": [
        "Assen",
        "Emmen",
        "Hoogeveen",
        "Meppel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad Drenthe",
            "content": "Assen is de hoofdstad van Drenthe. Drenthe ligt in het noordoosten van Nederland en is bekend om de hunebedden en het TT Circuit in Assen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "drenthe_hoofdstad",
      "variantIndex": 12,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Assen is de hoofdstad van Drenthe. De stad is bekend van het TT Circuit (motorrace). Emmen is de grootste stad van Drenthe.",
        "solutionSteps": [
          "Drenthe ligt in het noordoosten van Nederland",
          "De hoofdstad is Assen",
          "Emmen is de grootste stad, maar niet de hoofdstad"
        ],
        "distractorExplanations": {
          "0": "Goed! Assen is de hoofdstad van Drenthe.",
          "1": "Emmen is de grootste stad van Drenthe (bekend van het dierenpark), maar de hoofdstad is Assen.",
          "2": "Hoogeveen is een stad in Drenthe, maar niet de hoofdstad.",
          "3": "Meppel is een stad in het zuidwesten van Drenthe, maar niet de hoofdstad."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-012-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Emmen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-012-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Hoogeveen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-012-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Meppel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-013",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van de provincie Zeeland?",
      "options": [
        "Middelburg",
        "Vlissingen",
        "Goes",
        "Terneuzen"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad Zeeland",
            "content": "Middelburg is de hoofdstad van Zeeland. Zeeland ligt in het zuidwesten van Nederland en bestaat uit eilanden en schiereilanden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zeeland_hoofdstad",
      "variantIndex": 13,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Middelburg is de hoofdstad van Zeeland. De stad ligt op het eiland Walcheren. Zeeland is bekend om de Deltawerken.",
        "solutionSteps": [
          "Zeeland ligt in het zuidwesten van Nederland",
          "De hoofdstad is Middelburg (op Walcheren)"
        ],
        "distractorExplanations": {
          "0": "Goed! Middelburg is de hoofdstad van Zeeland.",
          "1": "Vlissingen ligt ook op Walcheren, maar is niet de hoofdstad. De hoofdstad is Middelburg.",
          "2": "Goes ligt op Zuid-Beveland, maar is niet de hoofdstad.",
          "3": "Terneuzen ligt in Zeeuws-Vlaanderen, maar is niet de hoofdstad."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-013-OPT1",
            "optionIndex": 1,
            "label": "De hoofdstad is Middelburg"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-013-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Goes"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-013-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Terneuzen"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-014",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van de provincie Utrecht?",
      "options": [
        "Utrecht",
        "Amersfoort",
        "Hilversum",
        "Zeist"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstad Utrecht",
            "content": "De stad Utrecht is de hoofdstad van de provincie Utrecht. Stad en provincie hebben dezelfde naam, net als bij Groningen. Utrecht ligt centraal in Nederland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "utrecht_hoofdstad",
      "variantIndex": 14,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De stad Utrecht is de hoofdstad van de provincie Utrecht. Net als bij Groningen hebben stad en provincie dezelfde naam. Utrecht is de vierde stad van Nederland.",
        "solutionSteps": [
          "Utrecht (stad) = hoofdstad van Utrecht (provincie)",
          "Utrecht is de vierde stad van Nederland",
          "Het ligt centraal in Nederland, een belangrijk knooppunt"
        ],
        "distractorExplanations": {
          "0": "Goed! Utrecht is de hoofdstad van de provincie Utrecht.",
          "1": "Amersfoort is de grootste stad van de provincie Utrecht, maar de hoofdstad is de stad Utrecht zelf.",
          "2": "Hilversum is bekend als mediastad, maar het ligt in Noord-Holland, niet in Utrecht.",
          "3": "Zeist is een gemeente in de provincie Utrecht, maar niet de hoofdstad."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-014-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Amersfoort"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-014-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Hilversum"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-014-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Zeist"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-015",
      "familyId": "TOPO-NL-STEDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_nl",
      "questionType": "matching",
      "question": "Koppel elke provinciehoofdstad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Haarlem",
            "right": "Noord-Holland"
          },
          {
            "left": "Den Haag",
            "right": "Zuid-Holland"
          },
          {
            "left": "Lelystad",
            "right": "Flevoland"
          },
          {
            "left": "'s-Hertogenbosch",
            "right": "Noord-Brabant"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Provinciehoofdsteden",
            "content": "Haarlem → Noord-Holland (niet Amsterdam!), Den Haag → Zuid-Holland (niet Rotterdam!), Lelystad → Flevoland (niet Almere!), 's-Hertogenbosch → Noord-Brabant (niet Eindhoven!).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoofdsteden_strikvragen",
      "variantIndex": 15,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Let op de strikvragen: de hoofdstad is niet altijd de grootste of bekendste stad! Haarlem (niet Amsterdam), Den Haag (niet Rotterdam), Lelystad (niet Almere), 's-Hertogenbosch (niet Eindhoven).",
        "solutionSteps": [
          "Haarlem → Noord-Holland (niet Amsterdam!)",
          "Den Haag → Zuid-Holland (niet Rotterdam!)",
          "Lelystad → Flevoland (niet Almere!)",
          "'s-Hertogenbosch → Noord-Brabant (niet Eindhoven!)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    }
  ]
}